import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isFunction from 'lodash/isFunction';
import { stringInterpolate } from '../formatters/string';
import getDataFromResponse from '../utils/getDataFromResponse';
import apiService, { getDefaultHeader, getCdmsUrl } from './apiService';
import { interceptResponse } from '../utils/sales';
var BASE_URL = getCdmsUrl();
var USERS_BASE_URL = '/userservice/u';
var API_PATHS = {
  GET_ALL_ROLES: '/settings/u/admin/roles',
  GET_ALL_USER_LIST: '/lookup/all',
  USER_AVAILABILITY: '/crmscheduler/u/employee/availability',
  GET_ALL_USERS_BY_PERSONA: "".concat(USERS_BASE_URL, "/v2/role-persona/user"),
  SEARCH_TENANT_USER: "".concat(USERS_BASE_URL, "/search/tenant-user"),
  ACCEPT_LEADS: '/crmlead/u/accept-leads',
  FETCH_SITES_BY_DEALER_ID: '/userservice/u/dealer/oem-sites/{dealerId}',
  GET_USER_IDS_BY_PERMISSIONS: '/settings/u/admin/v2/user-ids-by-permissions',
  USER_LOOKUP: "".concat(USERS_BASE_URL, "/v2/user/lookup"),
  USERS_SEARCH_BY_NAME: "".concat(USERS_BASE_URL, "/search/by-name"),
  USER_SEARCH: "".concat(USERS_BASE_URL, "/v2/search/user"),
  GET_USER_TIMEOUT_SETTINGS: "".concat(USERS_BASE_URL, "/user-timeout-settings"),
  GET_ALL_USERS_BY_ROLE: "".concat(USERS_BASE_URL, "/v2/user-details/role-persona")
};

var CommonAPI = /*#__PURE__*/function () {
  function CommonAPI() {
    _classCallCheck(this, CommonAPI);
  }

  _createClass(CommonAPI, null, [{
    key: "searchTenantUser",
    value: function searchTenantUser(payload) {
      return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.SEARCH_TENANT_USER, payload).then(getDataFromResponse);
    }
  }, {
    key: "fetchSitesByDealerId",
    value: function fetchSitesByDealerId(dealerId) {
      return apiService(BASE_URL, getDefaultHeader()).get(stringInterpolate(API_PATHS.FETCH_SITES_BY_DEALER_ID, {
        dealerId: dealerId
      })).then(getDataFromResponse);
    }
  }]);

  return CommonAPI;
}();

_defineProperty(CommonAPI, "fetchAllUserList", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.GET_ALL_USER_LIST, payload)["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "getAllRoles", function () {
  return apiService(BASE_URL, getDefaultHeader()).get(API_PATHS.GET_ALL_ROLES)["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "getAvailability", function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.USER_AVAILABILITY, payload)["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "getAllUsersByPersona", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.GET_ALL_USERS_BY_PERSONA, payload);
});

_defineProperty(CommonAPI, "getLeadAcceptingStatus", function () {
  return apiService(BASE_URL, getDefaultHeader()).get(API_PATHS.ACCEPT_LEADS).then(interceptResponse())["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "getMultipleLeadAcceptingStatuses", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post("".concat(API_PATHS.ACCEPT_LEADS, "/users-status"), payload).then(interceptResponse())["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "startAcceptingLeads", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post("".concat(API_PATHS.ACCEPT_LEADS, "/start"), payload).then(interceptResponse())["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "stopAcceptingLeads", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post("".concat(API_PATHS.ACCEPT_LEADS, "/stop"), payload).then(interceptResponse())["catch"](function (error) {
    return {
      error: error
    };
  });
});

_defineProperty(CommonAPI, "fetchUsersByPermissions", function (data) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.GET_USER_IDS_BY_PERMISSIONS, data).then(getDataFromResponse);
});

_defineProperty(CommonAPI, "fetchUsersInfo", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.USER_LOOKUP, payload).then(function (data) {
    return getDataFromResponse(data);
  })["catch"](function (error) {
    if (_isFunction(window.logMsgAtPuppeteer)) {
      window.logMsgAtPuppeteer('error occurred while fetching user details from user service lookup : ', error);
    }

    throw new Error("error occurred while fetching user details ".concat(JSON.stringify(error.data)));
  });
});

_defineProperty(CommonAPI, "searchUserByPersona", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post('/userservice/u/v2/user/by-persona', payload).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
});

_defineProperty(CommonAPI, "fetchUserBySearchText", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.USERS_SEARCH_BY_NAME, payload).then(getDataFromResponse);
});

_defineProperty(CommonAPI, "searchUsers", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.USER_SEARCH, payload).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
});

_defineProperty(CommonAPI, "fetchUsers", function (payload) {
  return apiService(BASE_URL, getDefaultHeader()).post('/userservice/u/v2/search/user', payload).then(function (_ref3) {
    var data = _ref3.data;
    return data;
  });
});

_defineProperty(CommonAPI, "fetchTimeOutSettings", function () {
  return apiService(BASE_URL, getDefaultHeader()).get(API_PATHS.GET_USER_TIMEOUT_SETTINGS);
});

export { CommonAPI as default };
export var getAllUsersByRole = function getAllUsersByRole(payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_PATHS.GET_ALL_USERS_BY_ROLE, payload).then(getDataFromResponse);
};